<template>
  <vs-prompt buttons-hidden title="Add Did You Know Product" :active="showNewDykProductDialog" @close="close">
    <div id="add-dyk-loading" class="p-2 vs-con-loading__container">
      <div style="overflow-y: scroll; max-height: 500px;">
        <vs-row vs-w="12" vs-type="flex" vs-align="center" v-for="product in availableProducts" :key="product.id">
          <vs-col vs-w="10" vs-type="flex" vs-align="center">
            <div>
              {{ product.product_name }}
            </div>
          </vs-col>
          <vs-col vs-w="2" vs-type="flex" vs-justify="flex-end" vs-align="center" class="pr-4">
            <div>
              <vs-icon size="20px" color="primary" type="flat" class="float-left" style="cursor:pointer;" icon="add_circle" @click="addProduct(product.product_id)" />
            </div>
          </vs-col>
          <vs-divider color="lightgray" class="mt-5 mb-4 pr-4"/>
        </vs-row>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
export default {
  props: [
    'showNewDykProductDialog',
    'availableProducts',
    'addDykProduct'
  ],
  data() {
    return {
      products: [],
      loading: false
    }
  },
  methods: {
    close() {
      this.$emit('update:showNewDykProductDialog', false);
    },
    async addProduct(product_id) {
      if(this.loading) return;
      this.showSpinnerOverCard();
      await this.addDykProduct(product_id);
      this.hideSpinnerOverCard()
    },
    showSpinnerOverCard() {
      this.loading = true;
      this.$vs.loading({
        container: `#add-dyk-loading`,
        scale: 0.6
      });
    },
    hideSpinnerOverCard() {
      this.loading = false;
      this.$vs.loading.close(`#add-dyk-loading > .con-vs-loading`)
    },
  }
}
</script>
